import PubSub from "underpub-js";
import OverlayScrollBars from "overlayscrollbars/js/jquery.overlayScrollbars.js";

var NavOverlay = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-NavOverlay',
	};

	$.extend(true, this.options, options);

};

NavOverlay.prototype.init = function() {

	var self = this;

	PubSub.subscribe('NavOverlay:show', function() {
	    
		self.show();

	});

	this.options.$el.find(`.${self.options.baseClass}__closeX`).on('click', function() {

		self.hide();

	});

	// overlay scroll bars
	this.options.$el.overlayScrollbars({
		className: null
	});

};

NavOverlay.prototype.show = function(){

	var self = this;

	self.options.$el.removeClass(`${self.options.baseClass}--hide`).addClass(`${self.options.baseClass}--active`);

};

NavOverlay.prototype.hide = function(){

	var self = this;

	self.options.$el.removeClass(`${self.options.baseClass}--active`).addClass(`${self.options.baseClass}--hide`);

	PubSub.publish('NavOverlay:closing');

};

export default NavOverlay;
